/**
 * Free gift picker (snippets/gift-picker.liquid): choose a gift product and size in the cart drawer,
 * then add it with the _free_gift property. Loaded by the cart drawer and the cart page; a separate file
 * because the drawer is re-rendered with innerHTML, which doesn't run inline scripts.
 */
if (!customElements.get('gift-variant-picker')) {
  customElements.define('gift-variant-picker', class extends HTMLElement {
    connectedCallback() {
      try { this.gifts = JSON.parse(this.dataset.gifts); } catch (e) { this.gifts = []; }
      this.productSelect = this.querySelector('[data-product]');
      this.variantSelect = this.querySelector('[data-variant]');
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      // Start on the first gift with something in stock.
      const firstInStock = this.gifts.findIndex((g) => g.variants.some((v) => v.available));
      this.productSelect.value = String(Math.max(0, firstInStock));
      this.productSelect.addEventListener('change', () => this.fillVariants());
      this.variantSelect.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.fillVariants();
    }
    fillVariants() {
      const gift = this.gifts[Number(this.productSelect.value)] || { variants: [] };
      this.variantSelect.hidden = gift.variants.length === 1;
      this.variantSelect.replaceChildren(...gift.variants.map((v) => {
        const option = document.createElement('option');
        option.value = v.id;
        option.textContent = v.available ? v.title : v.title + ' (sold out)';
        option.disabled = !v.available;
        return option;
      }));
      const first = gift.variants.find((v) => v.available);
      if (first) this.variantSelect.value = String(first.id);
      this.update();
    }
    current() {
      const gift = this.gifts[Number(this.productSelect.value)];
      return gift && gift.variants.find((v) => String(v.id) === this.variantSelect.value);
    }
    update() {
      const v = this.current();
      const ok = v && v.available;
      this.button.disabled = !ok;
      this.button.textContent = ok ? 'Add my free gift' : 'Sold out: pick another';
    }
    async add() {
      const v = this.current();
      if (!v || !v.available) return;
      this.button.disabled = true;
      this.button.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1, properties: { _free_gift: 'true' } }),
        });
        if (!res.ok) throw new Error((await res.json()).description || res.status);
        if (this.closest('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        } else {
          window.location.reload();
        }
      } catch (error) {
        this.status.textContent = 'Sorry, that size could not be added. Please try another.';
        this.update();
      }
    }
  });
}
